
import { CalendarViewType } from '@/_enums/calendar_view'
import { Constant } from '@/_services/constant'
import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment-timezone'
import { Filter } from '@/_utils/filter'
import BeaconModel from '@/_models/BeaconModel'
import CategoryModel from '@/_models/CategoryModel'
import UserModel from '@/_models/UserModel'
import { ResourceInterface, ITimelineFilter } from '@/_interfaces'

@Component({
  components: {},
})
export default class TimeLineVariablesMixins extends Vue {
  queryDateFormat: string = Constant.DATE_FORMAT_QUERY
  filterUtilPage: any = new Filter('filter_calendar_page')
  filterUtilPlaceMode: any = new Filter('filter_timeline_place_mode')
  calendar!: any
  isReady: boolean = false

  pageFilters: { dateFrom: string; dateTo: string } = {
    dateFrom: moment().startOf('day').format(Constant.DATE_FORMAT_QUERY),
    dateTo: moment().startOf('day').format(Constant.DATE_FORMAT_QUERY),
  }

  filtersData: ITimelineFilter = {
    selectedFilter: 'u_name',
    searchQuery: '',
  }

  filedNameLUT: any = {
    u_name: 'label.username',
    l_name: 'label.place',
    s_id: 'label.card_number',
    f_name: 'label.floor',
  }

  dateTimeFormat = 'YYYY-MM-DD HH:mm:ss'

  isPlaceMode: boolean = false
  stickyHeaders = true

  csvFields: string[] = [
    'san_id',
    'user_name',
    'beacon_id',
    'beacon_uuid',
    'beacon_major',
    'beacon_minor',
    'place_name',
    'floor',
    'start_at',
    'end_at',
  ]

  csvValues: any[] = []

  isMinimizeLegend: boolean = false
  isCSVAlready: boolean = false
  selectedSlotDuration = '02'

  timeOut: any = null
  loadedEvtsDateRange: string = ''

  currentDateView: string = CalendarViewType.day
  lastDayToJump
  intervalIndicator

  temporaryResources: ResourceInterface[] = []

  get beacons(): BeaconModel[] {
    return this.$store.state.beacons.all.items || []
  }

  set beacons(values: BeaconModel[]) {
    this.$store.commit('beacons/UPDATE_ALL_ITEMS', values)
  }

  get users(): UserModel[] {
    return this.$store.state.users.all.items_raw || []
  }

  get categories(): CategoryModel[] {
    return this.$store.state.categories.all.items || []
  }

  get calendarsData() {
    return this.$store.state.analysis.all.items
  }

  get dateFrom() {
    return moment(this.pageFilters.dateFrom).toDate()
  }

  get dateTo() {
    return moment(this.pageFilters.dateTo).toDate()
  }

  get isLoading(): boolean {
    return (
      this.$store.state.users.loading ||
      this.$store.state.beacons.loading ||
      this.$store.state.analysis.loading
    )
  }

  get resourceAreaColumns() {
    if (this.isPlaceMode) {
      return [
        {
          group: true,
          field: 'f_name',
          headerContent: 'Floors',
        },
        {
          field: 'l_name',
          headerContent: 'Places',
        },
      ]
    }

    return [
      {
        field: 'u_name',
        headerContent: 'Users',
      },
    ]
  }

  get csvFileName() {
    return `timeline_${this.pageFilters.dateFrom}_${this.pageFilters.dateTo}.csv`
  }

  get resources(): ResourceInterface[] {
    const resources: ResourceInterface[] = []

    if (!this.isPlaceMode) {
      this.users.forEach((user: UserModel) => {
        resources.push({
          id: this.getUserId(user),
          u_name: `[${this.getUserId(user)}] ${user.name}`,
          s_id: this.getUserId(user),
        })
      })
    } else {
      this.beacons.forEach((item: BeaconModel) => {
        if (item.floor_name || item.location_name) {
          resources.push({
            id: item._id,
            f_name: item.floor_name,
            l_name: item.location_name,
          })
        }
      })
      // Add outside place
      const locationName = this.$t('label.outside_title') as string
      const floorName = this.$t('label.outside_floor') as string
      resources.push({
        l_name: locationName,
        f_name: floorName,
        id: '0',
      })
    }

    const resourcesCheckID = resources.filter(item => item.id) // make sure exits item id
    this.temporaryResourceMediate = resourcesCheckID // set value for temporary resources

    return resourcesCheckID
  }

  get temporaryResourceMediate(): ResourceInterface[] {
    return this.temporaryResources
  }

  set temporaryResourceMediate(value: ResourceInterface[]) {
    this.temporaryResources = value
  }

  get resourcesUnique(): ResourceInterface[] {
    const resourcesSet: ResourceInterface[] = [...this.resources]
      .filter(
        (resource, index, array) =>
          array.findIndex(
            item => item[this.filtersData.selectedFilter] === resource[this.filtersData.selectedFilter]
          ) === index
      )
      .filter(option => {
        return (
          option[this.filtersData.selectedFilter || 'u_name']
            ?.toString()
            .toLowerCase()
            .indexOf(this.filtersData.searchQuery.toLowerCase()) >= 0
        )
      })

    return resourcesSet
  }

  getUserId(user: UserModel): string {
    return user.san_id || `${user.major}-${user.minor}`
  }
}
